module.exports = __webpack_public_path__ + "static/media/TheSeaKnowsmyNameBookCover.e0a6ce13.jpg";